"use client";
import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FlipBook from "@/components/FlipBook";

function VendorsPage() {
  const [getWidth] = useState(window.innerWidth);

  return (
    <>
      <section className="StyledSection">
        <Container>
          <Row style={{marginTop:"40px"}}>
            <Col className="py-2 py-lg-2">
              <FlipBook
                disableFlipByClick={true}
                usePortrait={getWidth < 420}
                width={getWidth < 420 ? 360 : 460}
                height={getWidth < 420 ? 470 : 600}
                showCover={true}
                startZIndex={50}
                autoSize={false}
                size="fixed"
                renderOnlyPageLengthChange={true}
              ></FlipBook>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default VendorsPage;
